"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var SelectDateModal = /*#__PURE__*/function (_Vue) {
  function SelectDateModal() {
    var _this;
    (0, _classCallCheck2.default)(this, SelectDateModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, SelectDateModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "typeSelect", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "date", [(0, _moment.default)().startOf("month").toDate(), (0, _moment.default)().endOf("month").toDate()]);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "format", "dd/MM/yyyy");
    (0, _defineProperty2.default)(_this, "type", "daterange");
    return _this;
  }
  (0, _inherits2.default)(SelectDateModal, _Vue);
  return (0, _createClass2.default)(SelectDateModal, [{
    key: "mounted",
    value: function mounted() {
      if (this.typeSelect == "month") {
        this.format = "MM/yyyy";
        this.type = "monthrange";
      }
    }
  }, {
    key: "onSubmitOk",
    value: function onSubmitOk() {
      this.visible = false;
      var format = this.typeSelect == "date" ? "YYYY-MM-DD" : "YYYY-MM";
      return {
        startDate: (0, _moment.default)(this.date[0]).format(format),
        endDate: (0, _moment.default)(this.date[1]).format(format)
      };
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.form = {};
      if (this.typeSelect == "month") {
        this.date = [(0, _moment.default)().startOf("year").toDate(), (0, _moment.default)().endOf("month").toDate()];
      } else {
        this.date = [(0, _moment.default)().startOf("month").toDate(), (0, _moment.default)().endOf("month").toDate()];
      }
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: "date"
})], SelectDateModal.prototype, "typeSelect", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submitOk")], SelectDateModal.prototype, "onSubmitOk", null);
SelectDateModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], SelectDateModal);
var _default = exports.default = SelectDateModal;